import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { withAutoMetric } from '@beef/auto-metric';
import { compose } from '@beef/redux';
import { enhancedConnect } from "../../utils";
import { Container } from "./Container";
import { HeadingGroup } from "../HeadingGroup";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var PageSectionLayout = function PageSectionLayout(_ref) {
  var anchorId = _ref.anchorId,
    children = _ref.children,
    heading = _ref.heading,
    subheading = _ref.subheading,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    _ref$innerSize = _ref.innerSize,
    innerSize = _ref$innerSize === void 0 ? 'default' : _ref$innerSize,
    _ref$headingSize = _ref.headingSize,
    headingSize = _ref$headingSize === void 0 ? 3 : _ref$headingSize,
    className = _ref.className;
  return /*#__PURE__*/React.createElement(Container, {
    attributes: {
      id: anchorId
    },
    className: className,
    innerSize: innerSize,
    type: type,
    "data-t-id": "components-PageSection"
  }, (heading || subheading) && /*#__PURE__*/React.createElement(HeadingGroup, {
    className: cn('headingGroup'),
    heading: heading,
    size: headingSize,
    subheading: subheading
  }), children);
};
export var PageSection = compose(enhancedConnect({
  children: PropTypes.node,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  type: PropTypes.oneOf(['default', 'filled']),
  innerSize: PropTypes.oneOf(['default', 'full']),
  headingSize: PropTypes.oneOf([0, 1, 2, 3, 4]),
  anchorId: PropTypes.string
}), withAutoMetric.Section(function (props) {
  return {
    id: props.anchorId,
    name: 'PageSection'
  };
}))(PageSectionLayout);